import React from 'react';
import { DatePicker } from '@trackman/web-shared-components';
import styled from 'styled-components';
import { white } from 'styles/Colors';

export const SessionsWrapper = styled.div`
  width: 400px;
  margin: auto;
`;

export const StyledDatePicker = styled((props) => <DatePicker {...props} />)`
  input:focus {
    outline: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 13px;
  align-items: center;
`;

export const PageTitle = styled.div`
  color: #414141;
  font-family: Lato;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: 35px;
  margin-bottom: 10px;
`;

export const SessionCard = styled.div`
  background: ${white};
  padding: 12px 12px 16px;
  border-radius: 8px;
`;

export const InputWrapper = styled.div`
  width: 100%;
`;

export const TeamWrapper = styled.div`
  margin-top: 10px;
`;